let cachedFixture = null
let pendingLoad = null

export async function loadDemoFixture() {
  if (cachedFixture) return cachedFixture
  if (!pendingLoad) {
    pendingLoad = import('./fixtures/999_123_results.json')
      .then((mod) => {
        cachedFixture = mod.default
        return cachedFixture
      })
      .finally(() => {
        pendingLoad = null
      })
  }
  return pendingLoad
}
